import { flowRight, get } from 'lodash/fp';
import { connect } from 'react-redux';
import { branch, renderNothing, withProps } from 'recompose';
import dataProvider from '../dataProvider';
import computeInvestorProfile from '../../common/model/rip/investorProfile';

const profileProvider = flowRight([
    // get the rip
    dataProvider({
        id: ({ params: { id } }) => id,
        type: 'rip',
        prop: 'rip',
        wait: true,
    }),

    withProps(({ params: { target = 'client' }, rip }) => {
        if ('client&partner' === target) {
            return {
                target,
                investorProfile: {
                    client: computeInvestorProfile(get('investorProfiles.client', rip)),
                    partner: computeInvestorProfile(get('investorProfiles.partner', rip)),
                },
            };
        }

        return {
            target,
            investorProfile: computeInvestorProfile(get(`investorProfiles.${target}`, rip)),
        };
    }),

    branch(
        ({ target, investorProfile }) => {
            if ('client&partner' === target) {
                const clientInvalid = [null, 'declined'].includes(investorProfile.client);
                const partnerInvalid = [null, 'declined'].includes(investorProfile.partner);

                return clientInvalid && partnerInvalid;
            }

            return [null, 'declined'].includes(investorProfile);
        },
        renderNothing,
    ),

    connect(({ investorProfile: next }) => ({ next })),
]);

export default profileProvider;
